function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
(function(root, factory, undef) {
    if ((typeof exports === "undefined" ? "undefined" : _type_of(exports)) === "object") {
        // CommonJS
        module.exports = exports = factory(require("./core"), require("./cipher-core"));
    } else if (typeof define === "function" && define.amd) {
        // AMD
        define([
            "./core",
            "./cipher-core"
        ], factory);
    } else {
        // Global (browser)
        factory(root.CryptoJS);
    }
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function pad() {},
        unpad: function unpad() {}
    };
    return CryptoJS.pad.NoPadding;
});
